import { RootState } from './store';

// Avoid circular imports when using selectors from a different slice by defining the outside selectors here
export const getKits = (state: RootState) => state.kits.kits;
